import StrongWoolIndexChart from "../vue/StrongWoolIndexChart.vue";
import HeroIndex from "../vue/HeroIndex.vue";
import WoolPriceCheck from "../vue/WoolPriceCheck.vue";
import * as Vue from 'vue';
import axios from "axios";

// Intiate Vuejs instance if we find #appVue (just in strong wool index page)

window.axios = axios;
window.axios.defaults.baseURL = process.env.MIX_SHOP_API_URL;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
window.axios.defaults.headers.common['Authorization'] = `Bearer ${process.env.MIX_VUE_APP_SANCTUM}`;
window.axios.defaults.headers.common['Accept'] = 'application/json';

// The Strong Wool Indicator strip used to mount here. It is now rendered entirely
// by _blocks/strongWoolIndex.twig from the cached strongWoolIndex() Twig function,
// so the figure is in the HTML crawlers read instead of being painted in on mount.
// Nothing to hydrate: mounting an app over it would only re-fetch what the server
// already resolved.

const strongWoolIndexChart = document.getElementById("strongWoolIndexChart");
if (strongWoolIndexChart) {
    Vue.createApp({
        components: {
            StrongWoolIndexChart,
        }
    }).mount("#strongWoolIndexChart");
}

// Hero instrument panel. Mounts directly over the markup home-banner.twig already
// rendered, seeded with the same payload via data-initial, so the figure never
// flashes back to zero. Teleporting here would append to the server-rendered cells
// and print each figure twice.
const heroIndex = document.getElementById("heroIndex");
if (heroIndex) {
    let initial = null;
    try {
        initial = heroIndex.dataset.initial ? JSON.parse(heroIndex.dataset.initial) : null;
    } catch (e) {
        initial = null;
    }

    Vue.createApp(HeroIndex, {
        chartUrl: heroIndex.dataset.chartUrl || '',
        initial: initial,
    }).mount("#heroIndex");
}

/* Hero price check.
 *
 * Renders the 180-day result inline instead of handing the visitor to
 * app.fusca.co.nz on their first click. It progressively enhances the plain GET
 * form beside it: the component attaches to that form's submit, so with JS off
 * the original handoff still works.
 *
 * The data comes through Craft (see PreviewController) rather than from the
 * dataengine directly, so the browser request is same-origin and there is no CORS
 * to configure or to fail differently in dev. appBase is only used for the link
 * out to the full tool. */
const priceCheck = document.getElementById("woolPriceCheck");
if (priceCheck) {
    Vue.createApp(WoolPriceCheck, {
        pricesUrl: priceCheck.dataset.pricesUrl || '',
        subscribeUrl: priceCheck.dataset.subscribeUrl || '',
        csrfName: priceCheck.dataset.csrfName || '',
        csrfToken: priceCheck.dataset.csrfToken || '',
        appBase: priceCheck.dataset.appBase || '',
    }).mount("#woolPriceCheck");
}
